module.exports = __webpack_public_path__ + "media/images/icons/arrow-collapse-3793b0d33dc93244658df5e7cead5937.svg";